import React, { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react';
import classNames from 'classnames';


import './VoteButton.scss';

export interface VoteButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  voteType: 'up' | 'down';
  label?: string;
  handleVoteClick?: () => void;
}

const VoteButton: FC<VoteButtonProps> = ({ voteType, handleVoteClick, label, ...props }) => (
  <button
    {...props}
    onClick={handleVoteClick}
    className={classNames('react-vote-button', props.className, {
      'is-down': voteType === 'down',
      'is-up': voteType === 'up',
    })}
    type="button"
  >
    {label}
  </button>
);

export default VoteButton;
